/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type ActionItemStatus =
	(typeof ActionItemStatus)[keyof typeof ActionItemStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionItemStatus = {
	pending: 'pending',
	completed: 'completed',
} as const;
